/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 22:46:18
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-27 22:41:56
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/PopReminder/Warning/index.tsx
 */
import React from 'react';

import css from './css.less';

import PopReminder from '../index';

import { InfoCircleOutlined } from '@ant-design/icons';
import { Button } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const WarningPopReminder = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [visible, setVisible] = React.useState(false);
  const {
    title,
    content,
    onOk,
    onCancel,
    onOkText,
    onCancelText,
    children,
    visibilityOption = {},
    placement,
    id,
  } = props;
  const { controlledByParent, controlledVisible, setControlledVisible } =
    visibilityOption || {};
  const handleOnOk = (e) => {
    e.stopPropagation();
    if (onOk) onOk(e);
    if (controlledByParent) {
      setControlledVisible(false);
    } else {
      setVisible(false);
    }
  };
  const handleOnCancel = (e) => {
    e.stopPropagation();
    if (onCancel) onCancel(e);
    if (controlledByParent) {
      setControlledVisible(false);
    } else {
      setVisible(false);
    }
  };
  return (
    <PopReminder
      id={id}
      setVisible={(e) => {
        if (controlledByParent) {
          if (!e && setControlledVisible) {
            setControlledVisible(false);
          }
        } else {
          setVisible(e);
        }
      }}
      visible={controlledByParent ? controlledVisible : visible}
      placement={placement || 'top'}
      content={
        <div className={css.container} onClick={(e) => e.stopPropagation()}>
          <div className={css.titleContainer}>
            <InfoCircleOutlined className={css.icon} />
            <div className={css.title}>{title}</div>
          </div>
          <div className={css.content}>{content}</div>
          <div className={css.buttonContainer}>
            <Button onClick={handleOnCancel} className={css.cancel}>
              {onCancelText || getI18n('general.cancel')}
            </Button>
            <Button onClick={handleOnOk} type='danger' className={css.ok}>
              {onOkText || getI18n('general.antd.Modal.ModalFooter.delete')}
            </Button>
          </div>
        </div>
      }
      title={null}>
      {children}
    </PopReminder>
  );
};
export default WarningPopReminder;
